// 30% off, active only on June 23, 2026 in the VISITOR'S local timezone.
// Each user sees the discount during their own local June 23 (00:00–23:59).
// Auto-expires after midnight local time — no code change needed to revert.

export const DISCOUNT_PERCENT = 30;
export const DISCOUNT_NAME = '24-Hour Flash Sale';
export const DISCOUNT_DATE_LABEL = 'June 23, 2026';

const PROMO_YEAR = 2026;
const PROMO_MONTH = 5; // June (0-indexed)
const PROMO_DAY = 23;

export const isDiscountActive = () => {
  const now = new Date();
  return (
    now.getFullYear() === PROMO_YEAR &&
    now.getMonth() === PROMO_MONTH &&
    now.getDate() === PROMO_DAY
  );
};

// Apply the active discount to a numeric price (rounded to 2 decimal places).
export const applyDiscount = (price) => {
  if (!isDiscountActive()) return price;
  const discounted = (Number(price) * (100 - DISCOUNT_PERCENT)) / 100;
  return Math.round(discounted * 100) / 100;
};
